<template>
  <div>
    <b-card title="You need LOGIN"
          img-src="https://images.unsplash.com/photo-1509822929063-6b6cfc9b42f2?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=e1f57036c9c3ef1d85d9ea7bc19ccb57&auto=format&fit=crop&w=300&q=40"
          img-alt="Image"
          img-top
          tag="article"
          class="loginForm">
      <b-button size="lg" variant="primary" @click=gLogin>Google Login</b-button>
    </b-card>
  </div>
</template>


<script>
import { authRef } from '../store/db.js';
export default {
    data(){
      return{
         form: {
            email: '',
            name: ''
          },
          show: true
      }
    },
    methods:{
        gLogin(){
            this.$store.dispatch('userAuth');
        },
        onSubmit (evt) {
            evt.preventDefault();
            alert(JSON.stringify(this.form));
        },
      onReset (evt) {
            evt.preventDefault();
            /* Reset our form values */
            this.form.email = '';
            this.form.name = '';
            /* Trick to reset/clear native browser form validation state */
            this.show = false;
            this.$nextTick(() => { this.show = true });
      }
    },
    beforeCreate(){
        authRef.onAuthStateChanged(user=>{
            if(user){
              this.$router.push('todo');
            }

        });
    }
}
</script>
<style>
 
</style>



// WEBPACK FOOTER //
// src/components/TodoLogin.vue